import {take, fork, all, call, put} from 'redux-saga/effects';
import * as constants from '../constants';
import * as api from '../services/api';
import {logout} from '../actions/action_auth';
import * as actions from '../actions/action_media_list';

function* watchList() {
    while (true) {
        const {payload} = yield take(constants.MEDIA_LIST_REQUESTED);
        try {
            const response = yield call(api.fetchMediaList, payload.offset, payload.limit, payload.filter, payload.sort);
            yield put(actions.mediaListSuccess(response.data));
        } catch (error) {
            if (error.response && error.response.status === 401) {
                yield put(logout());
            }
            yield put(actions.mediaListFailure(error));
        }
    }
}

function* watchUpload() {
    while (true) {
        const {payload} = yield take(constants.MEDIA_UPLOAD_REQUESTED);
        try {
            const response = yield call(api.uploadMedia, payload.file);
            yield put(actions.mediaUploadSuccess(response.data));
        } catch (error) {
            if (error.response && error.response.status === 401) {
                yield put(logout());
            }
            yield put(actions.mediaUploadFailure(error));
        }
    }
}

function* watchDelete() {
    while (true) {
        const {payload} = yield take(constants.MEDIA_DELETE_REQUESTED);
        try {
            yield call(api.deleteMedia, payload.id);
            yield put(actions.mediaDeleteSuccess(payload.id));
        } catch (error) {
            if (error.response && error.response.status === 401) {
                yield put(logout());
            }
            yield put(actions.mediaDeleteFailure(error, payload.id));
        }
    }
}

export default function* root() {
    yield all([
        fork(watchList),
        fork(watchUpload),
        fork(watchDelete),
    ]);
}
